import React, {useState, useCallback} from 'react'
import {AnimatePresence, motion} from 'framer-motion'
import CloseSymbol from '../../assets/svg/close-big.inline.svg'
import './EmbedContainer.scss'

export default function EmbedContainer({embed, close}) {

	const [active, setActive] = useState(true)

	const closeButton = useCallback(node => {
		if(node !== null) {
			node.focus()
		}
	}, [])

	const closePlayer = () => {
		setActive(false)
		setTimeout(() => {
			close()
		}, 1000)
	}

	return(
		<AnimatePresence>
			{	active &&
				<div className="EmbedContainer">
					<div className="inner">
						<motion.button
							ref={closeButton}
							className="closePlayer"
							onClick={closePlayer}
							initial={{opacity: 0, y: -200}}
							animate={{opacity: 1, y: 0, transition: {delay: .5}}}
							exit={{opacity: 0}}
							aria-expanded={true}
						>
							<span>Lukk</span>
							<CloseSymbol />
						</motion.button>
						<motion.div
							className="embed"
							initial={{opacity: 0, y: 200}}
							animate={{opacity: 1, y: 0, transition: {delay: .5}}}
							exit={{opacity: 0, transition: {delay: .3}}}
							dangerouslySetInnerHTML={{__html: embed}}
						/>
					</div>
					<motion.div
						className="background"
						initial={{opacity: 0}}
						animate={{opacity: .9}}
						exit={{opacity: 0}}
					/>
				</div>
			}
		</AnimatePresence>
	)
}